module.exports = __webpack_public_path__ + "img/logo-company.250732bb.png";